<template>
  <Container :isLoadingShow="isLoadingShow" :isFixed="false">

 <div class="container-1">
    <div class="tabs">
      <ul>
        <li v-for="(item,index) in sidebarData" :key="index">
          <a href="javascript:;" @click="columnClick(item.ID)">
            <img :src="$getImageUrl(item.Pic)" width="215px" height="120px"></a>
        </li>
      </ul>
    </div>
    <div class="content">
      <div class="main-text">

        <div class="pane"  v-html="$textareaFormatter(this.currentData.Content)">
        </div>

      </div>
      <div class="sidebar">

          <div class="contact">
           <div class="title" :class="'title-'+getLanguageName" >{{contactTitle}}</div>
          <div class="text"  v-html="$textareaFormatter(contactContent)">
       
          </div> 
          </div>
       
      </div>
    </div>
  </div>


  </Container>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: "about",
 components: {Container},
  data() {
    return {

      isLoadingShow:true,

      id:0,

      model:[],
      
      currentData:{BigPic:[]},//当前模块数据

      sidebarData:[],//页面右侧数据     


      imgSrc:'',
      contactModel:[],

      contactTitle:'',
      contactContent:'',

  


    }
  },
  methods: {
    //获取数据
    getData(){

       this.$request.get("/about",{params:{id:this.id}}).then((res)=>{
              if (res.data.code === 0) {
                  this.model= res.data.data;
                  this.changeData();
              } 

              this.isLoadingShow = false
      })

      this.$request.get("/contact").then((res)=>{

        if (res.data.code === 0) {
            this.contactModel= res.data.data;

            this.changeContactData()
        } 
      })

    },

    changeContactData(){
      if(this.contactModel){
         if(this.$store.state.language.name==='cn'){
           this.imgSrc = this.contactModel.ContactPic
           this.contactTitle= this.contactModel.ContactTitle
           this.contactContent = this.contactModel.ContactContent
         }else{
           this.imgSrc = this.contactModel.ContactPicEn
           this.contactTitle= this.contactModel.ContactTitleEn
           this.contactContent = this.contactModel.ContactContentEn
         }
      }
    },

    changeData(){
      if(this.model){
        this.getCurrentData()
        this.getSidebarData()
     
      } 
    },

    getCurrentData(){
      this.currentData = {}
      let info = this.model.AboutSet.find(item => item.ID === this.id)
      if(info){
           if(this.$store.state.language.name==='cn'){
      
             this.currentData = { ID:info.ID,Title:info.AboutTitle,Content:info.ItemContent, Pic:info.Pic,BigPic:info.BigPic.split(',') }
          }else{
         
             this.currentData = { ID:info.ID,Title:info.AboutTitleEn,Content:info.ItemContentEn, Pic:info.PicEn,BigPic:info.BigPicEn.split(',') }
          }       
      }

      
    },    


    getSidebarData(){
      this.sidebarData = []
      let list = this.model.AboutSet;//.filter(item => item.ID !== this.id)
      list.forEach(item=>{
           if(this.$store.state.language.name==='cn'){
           
              this.sidebarData.push( { ID:item.ID,Title:item.AboutTitle,Content:item.ItemContent, Pic:item.Pic,BigPic:item.BigPic.split(',') })
          }else{
          
              this.sidebarData.push({ ID:item.ID,Title:item.AboutTitleEn,Content:item.ItemContentEn, Pic:item.PicEn,BigPic:item.BigPicEn.split(',') })
          }
      })
    },

    columnClick(id) {
      this.id = id 
      this.changeData()

    },

  },

  computed: {
    getLanguageName(){
      return this.$store.state.language.name
    },
  },

  mounted() {
    this.id = this.$route.query.id
    if(!this.id){
      this.id = 1
    }
    this.getData()
    this.changeContactData()

  },

  watch:{
    getLanguageName(){
      this.changeData()
      this.changeContactData()
    }
  }
}
</script>

<style scoped lang="scss">
  .container-1 {
      margin: 0 auto;
      width: 1320px;
     /*  width: 1080px; */
      padding-top: 210px;
      margin-left: 300px;
      margin-right: 300px;
    }

    .tabs {
      margin-bottom: 130px
    }

    .tabs ul {
      display: flex;
      justify-content: space-between;
    }

    .tabs ul li {
      cursor: pointer
    }

    .content {
  
      display: flex;
      justify-content: space-between;
    }

    .main-text {
      flex: 2;
      padding-right: 80px;
      font-size: 14px;
      line-height: 22px;
     
    }

   

    .main-text .pane {
      display: block;
      width: 1024px;
      overflow: hidden;
        
    }


    .sidebar {
      width: 215px;
    }

    .sidebar .contact .title {
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 28px;
    color: #020202;
}

 .sidebar .contact .text {
    color: #818181;
    font-size: 14px;
}
</style>


